import * as React from 'react'
import {ReactChild, ReactElement} from 'react'
import {
  createStyles,
  Icon,
  TableCell,
  TableRow,
  Theme,
  WithStyles,
  withStyles,
  Checkbox
} from '@material-ui/core'
import {datatableConsumer, IDatatableContext} from './Datatable'
import {RootState} from '../../core/redux/reducer/index'
import {connect} from 'react-redux'
import autobind from 'autobind-decorator'
import {withI18n} from '../../core/i18n'
import {compose} from 'redux'
import {WithI18n} from '../../core/i18n/withI18n'
import {PanelContent} from '../Panel'
import classNames from 'classnames'

const styles = (t: Theme) => createStyles({
  root: {
    transition: t.transitions.create('all'),
    opacity: 0,
  },
  root_appeared: {
    opacity: 1,
  },
  expend: {
    // margin: `-1px -${t.spacing.unit}px`,
    background: t.palette.background.paper,
    // minHeight: 50,
    // boxShadow: t.shadows[2],
    // position: 'relative',
    // top: 48
    // padding: t.spacing.unit,
  },
  row: {
    '& > td:first-child': {
      borderLeft: `2px solid ${t.palette.primary.main}`
    }
  },
  cell: {
    borderLeft: `2px solid ${t.palette.primary.main}`
  }
})

interface IProps extends IDatatableContext,
  WithI18n,
  WithStyles<typeof styles> {
  children: ReactElement<any>
  expend?: boolean
  index: number
  expendedChild?: ReactChild,
  selected: number[],
  onSelect: (indexes: number[]) => void
}

class DatatableRow extends React.Component<IProps & ReturnType<typeof state2props>> {

  state = {
    appeared: false,
  };

  private timeout: any;

  render() {
    const {children, expendedChild, classes, onSelect, selected, index} = this.props;
    return (
      <>
        <TableRow hover
                  className={classNames(classes.root, this.state.appeared && classes.root_appeared, this.isExpended() ? classes.row : '')}>
          {onSelect &&  
            <TableCell key={1}>
              <Checkbox checked={selected.indexOf(index) !== -1} onClick={this.handleSelect(index)}/>
            </TableCell>
          }  
          {expendedChild &&
            <TableCell
              style={{width: 30}}
            >
                <Icon
                  onClick={this.toggle}
                  style={{cursor: 'pointer'}}
                >
                  {this.isExpended() ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                  </Icon>
            </TableCell>
          }

          {children[1].map(c => {
            if(c.type){
              return React.cloneElement(c, {
                style: {
                  overflowX: 'hidden',
                  textOverflow: 'ellipsis',
                  ...c.props.style && {...c.props.style}
                }
              })
            } else return '';
          })}

        </TableRow>
        {this.isExpended() &&
        <TableRow>
          <TableCell colSpan={100} className={classes.cell}>
            <PanelContent>
              {expendedChild}
            </PanelContent>
          </TableCell>
        </TableRow>
        }
      </>
    )
  }

  componentDidMount() {
    const {index} = this.props
    this.timeout = setTimeout(() => this.setState({appeared: true}), index * 30)
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  isExpended(): boolean {
    const {index, expendedRow} = this.props
    return index === expendedRow
  }

  @autobind
  private handleSelect(i: number) {
    return (event) => {
      event.stopPropagation()
      const {onSelect, selected} = this.props
      const x = selected.indexOf(i)
      if (x === -1) {
        selected.push(i)
      } else {
        selected.splice(x, 1)
      }
      onSelect([...selected])
    }
  }

  @autobind
  private toggle() {
    const {index, expendRow} = this.props
    expendRow(index)
  }
}

const state2props = (state: RootState, ownProps: IProps) => {
  const paginateState = state.paginate[ownProps.name]
  return {
    criteria: paginateState.criteria,
    data: paginateState.entities,
  }
}

export default compose(
  withI18n,
  datatableConsumer,
  connect(state2props),
  withStyles(styles),
)(DatatableRow)



// WEBPACK FOOTER //
// ./src/shared/Datatable/DatatableRow.tsx